























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class NandaDiagnosaChecklist extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: Record<string, boolean>;
  @Prop({ default: false }) readonly disabled!: boolean;

  localValue: Record<string, boolean> = {};

  nandaItems = [
    { key: "ansietas", label: "Ansietas (D.0080)" },
    { key: "nyeri_akut", label: "Nyeri Akut (D.0077)" },
    { key: "risiko_infeksi", label: "Risiko Infeksi (D.0142)" },
    { key: "risiko_cedera", label: "Risiko Cedera (D.0136)" },
    { key: "risiko_perdarahan", label: "Risiko Perdarahan (D.0012)" },
    { key: "risiko_jatuh", label: "Risiko Jatuh (D.0143)" },
    { key: "risiko_aspirasi", label: "Risiko Aspirasi (D.0006)" },
    { key: "risiko_hipotermi_perioperatif", label: "Risiko Hipotermi Perioperatif (D.0141)" },
    { key: "risiko_syok", label: "Risiko Syok (D.0039)" },
    { key: "termoregulasi_tidak_efektif", label: "Termoregulasi Tidak Efektif (D.0149)" }
  ];

  mounted() {
    this.localValue = { ...this.value };
  }

  @Watch("value", { deep: true })
  onValueChange(val) {
    this.localValue = { ...val };
  }

  emitChange() {
    this.$emit("input", { ...this.localValue });
  }
}
